import { useState } from "react";

export interface FaqItem {
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span className="flex items-start gap-3">
                  <span className="font-label text-xs text-accent-700 bg-accent-100 rounded-md px-2 py-1 shrink-0 mt-0.5">
                    Q{index + 1}
                  </span>
                  <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {item.q}
                  </span>
                </span>
                <span className="w-7 h-7 shrink-0 rounded-full bg-background-100 border border-background-200 flex items-center justify-center text-foreground-700 mt-0.5">
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="pb-6 pl-0 md:pl-12 pr-2">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}